<template>
  <path
    d="M11.29 8.71022L6.7 13.3002C6.31 13.6902 6.31 14.3202 6.7 14.7102C7.09 15.1002 7.72 15.1002 8.11 14.7102L12 10.8302L15.88 14.7102C16.27 15.1002 16.9 15.1002 17.29 14.7102C17.68 14.3202 17.68 13.6902 17.29 13.3002L12.7 8.71022C12.32 8.32022 11.68 8.32022 11.29 8.71022Z"
  />
</template>
